import type {ActivityArea, PostalAddress, Skill} from '@api';

export enum ResumeImportExperienceSource {
    RESUME = 'RESUME',
    MALT = 'MALT',
}

export type ResumeImportExperience = {
    id?: string;
    company?: string;
    companyId?: string;
    title?: string;
    area?: ActivityArea;
    location?: PostalAddress;
    startDate?: Date;
    endDate?: Date;
    currentJob?: boolean;
    asFreelancer?: boolean;
    recommendationCount?: number;
    description?: string;
    source?: ResumeImportExperienceSource;
    tags: string[];
    skills: Skill[];
};
